require('./contractEasyLoanTypeCSuccessStep.scss');

const PropTypes = require('prop-types');

// @ vendors    
const React = require('react');
// @ commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
//@utilities
const { getFormattedString } = require('utilities/currencyHelper');
const { recordLinkV2 } = require('utilities/tagging');
//@constants
const { PERCENTAGE_SYMBOL } = require('constants/index');
const { catalogue, analyticsId } = require('../analytics/contractEasyLoanApprovedTypeC.tracking');
const { recordEasyLoanCBackGlobalPositionButton } = require('../../contractEasyLoanTypeC/analytics/contractEasyLoanTypeC.tracking');

class ContractEasyLoanTypeCSuccessStep extends React.Component {

    constructor(props) {
        super(props);

        this.handleMainButtonClick = this.handleMainButtonClick.bind(this);
    }
    componentDidMount() {
        recordLinkV2(
            catalogue[analyticsId.CONTRACT_EASY_LOAN_STEP_2_SUCCESS]()
        );
    }

    buildList() {
        const { immContractEasyLoanTypeC } = this.props;

        const fields = [
            {
                title: formatText('contractEasyLoanTypeCSuccess-loanImport'),
                bodyText: getFormattedString({
                    amount: immContractEasyLoanTypeC.get('selectedAmount'),
                    decimalsLength: 0,
                    currency: immContractEasyLoanTypeC.get('currency')
                })
            },
            {
                title: formatText('contractEasyLoanTypeCSuccess-anualTin'),
                bodyText: this.formatInterest(immContractEasyLoanTypeC.get('tin'))
            },
            {
                title: formatText('contractEasyLoanTypeCSuccess-term'),
                bodyText: formatText('contractEasyLoanTypeCSuccess-termMonths', [immContractEasyLoanTypeC.get('selectedTerm')])
            },
            {
                title: formatText('contractEasyLoanTypeCSuccess-monthlyInstallment'),
                bodyText: getFormattedString(immContractEasyLoanTypeC.get('installment'))
            },
            {
                title: formatText('contractEasyLoanTypeCSuccess-TAE'),
                bodyText: this.formatInterest(immContractEasyLoanTypeC.get('tae'))
            },
        ];

        return fields.map((field, index) => {
            return (
                <OKInformativeListItem
                    key={field.title + index}
                    title={field.title}
                    bodyText={field.bodyText}
                />
            );
        });
    }

    formatInterest(value) {
        return value.toString().replace(/\./, ',').concat(' ', PERCENTAGE_SYMBOL);
    }

    handleMainButtonClick() {
        const { goToGlobalPosition } = this.props;
        recordEasyLoanCBackGlobalPositionButton()
        goToGlobalPosition();
    }

    render() {
        const { immContractEasyLoanTypeC, success } = this.props;
        const title = success ? formatText('contractEasyLoanTypeCSuccess-titleSuccess') : formatText('contractEasyLoanTypeCSuccess-title');

        const subMessage = (
            <span>
                <FormattedText value={success ? "contractEasyLoanTypeCSuccess-subMessageSuccess" : "contractEasyLoanTypeCSuccess-subMessage"} />
                <span className="contract-easy-loan-success-step__account">
                </span>
            </span>
        );

        const listItems = this.buildList();

        const goToGlobal = {
            label: formatText('contractEasyLoanTypeCSuccess-goToGlobal').toUpperCase(),
            url: 'myprofile/global'
        };

        return (
            <article className="contract-easy-loan-success-step row no-gutter">
                <div className="col-xs-offset-1 col-xs-9">
                    <WizardSuccess
                        successMessage={title}
                        successSubMessage={subMessage}
                        mainButton={goToGlobal}
                        secondaryButtonStyle="link-complementary"
                        tealium={catalogue[analyticsId.CONTRACT_EASY_LOAN_WIZARD_SUCCESS]({ data: this.formatInterest(immContractEasyLoanTypeC.get('minTae')) })}
                        onMainButtonClick={this.handleMainButtonClick}
                        isSecondVersion
                    >
                        <div className="contract-easy-loan-success-step__separator" />
                        <OKInformativeList columns={2}>
                            {listItems}
                        </OKInformativeList>
                    </WizardSuccess>
                </div>
            </article>
        );
    }
}

ContractEasyLoanTypeCSuccessStep.propTypes = {
    immContractEasyLoanTypeC: PropTypes.object.isRequired,
    goToGlobalPosition: PropTypes.func.isRequired,
};

module.exports = ContractEasyLoanTypeCSuccessStep;
